<div class="container d-flex flex-column justify-content-center align-items-center vh-100">
      <img class="img rounded-circle mb-3" [src]="labo?.logo" src="" alt="" style="width: 50%; height: 50%;">
      <div class="py-2">
        <mat-spinner [diameter]="80" color="accent"></mat-spinner>
      </div>
</div>
